import React, { Component } from 'react';
import { Tab, Tabs } from 'material-ui/Tabs';
import Alert from 'react-s-alert';
import AvailabilityTemplate from './AvailabilityIndex';
import { connect } from 'react-redux';
import CustomFields from './CustomFields';
import FontIcon from 'material-ui/FontIcon';
import UserInfo from './UserInfo';
import UserInfoHeader from './UserInfoHeader';
import {base64Decode} from '../../../actions/utilAction';

class User extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      open: true,
      activeTab: 0,
      activeTabValue: '0',
      staffId: props.match.params.id ? base64Decode(props.match.params.id) : null,
    });
    this.handleUserTabChange = this.handleUserTabChange.bind(this);
  }
  componentWillMount() {
    this.handleUserTabChange('0');
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.handleUserTabChange('0');
      this.setState({ staffId: nextProps.match.params.id ? base64Decode(nextProps.match.params.id) : null });
    }
  };

  setActive(tabValue) {
    this.setState({ activeTab: parseInt((tabValue || 0), 10) });
  }

  handleOpen = () => {
    this.setState({ open: true,
    });

  };
  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();

  };
  handleUserTabChange = (value) => { //  Change Tab on form Submit.
    Alert.closeAll();
    this.setState({ activeTabValue: value, activeTab: parseInt((value || 0), 10) });
  };

  render() {
    var styles = {
      default_tab: {
        height: '50px',
        fontSize: '13px',
      },
      active_tab: {
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.10)',
        height: '48px',
        fontSize: '13px',
      },
    };
    styles.tab = [];
    styles.tab[0] = styles.default_tab;
    styles.tab[1] = styles.default_tab;
    styles.tab[2] = styles.default_tab;
    styles.tab[3] = styles.default_tab;
    styles.tab[4] = styles.default_tab;
    styles.tab[5] = styles.default_tab;
    styles.tab[this.state.activeTab] = styles.active_tab;
    styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
    return (
      <div>
        <div>
          {this.state.staffId ?
            <UserInfoHeader staffId={this.state.staffId} />
            : '' }
          <Tabs className="custom_tabs" value={this.state.activeTabValue} onChange={this.handleUserTabChange}>
            <Tab
              onClick={(e) => this.setActive(0)}
              style={styles.tab[0]}
              value="0"
              className="customtab"
              icon={<FontIcon className="material-icons">local_library</FontIcon>}
              label={<font>User Info</font>}>
              <div className="readmin-panel">
                <div className="panel-body">
                  {this.state.activeTab === 0 ?
                    <UserInfo staffId={this.state.staffId} handleUserTabChange = {this.handleUserTabChange}/>
                    : '' }
                </div>
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(1)}
              value="1"
              disabled={!this.state.staffId}
              style={styles.tab[1]}
              className="customtab"
              icon={<FontIcon className="material-icons">build</FontIcon>}
              label={<font>Custom fields</font>}>
              <div className="readmin-panel">
                <div className="panel-body">
                  {this.state.activeTab === 1 ?
                    <CustomFields staffId={this.state.staffId} handleUserTabChange = {this.handleUserTabChange}/>
                    : ''}
                </div>
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(2)}
              value="2"
              disabled={!this.state.staffId}
              style={styles.tab[2]}
              className="customtab"
              icon={<FontIcon className="material-icons">today</FontIcon>}
              label={<font>Availability</font>}>
              <div className="readmin-panel">
                <div className="panel-body">
                  {this.state.activeTab === 2 ?
                    <AvailabilityTemplate staffId={this.state.staffId} />
                    : null }
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default connect(null, { })(User);



// WEBPACK FOOTER //
// ./src/modules/users/User/index.js